import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-finance-manager",
  "use": "icon-finance-manager-usage",
  "viewBox": "0 0 16 15.999",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15.999\" id=\"icon-finance-manager\">\r\n    <defs>\r\n    </defs>\r\n    <path class=\"a\" d=\"M6.4,16A6.407,6.407,0,0,1,0,9.6V6.4A6.407,6.407,0,0,1,6.4,0H9.6A6.407,6.407,0,0,1,16,6.4V9.6A6.407,6.407,0,0,1,9.6,16Zm-5-9.4V9.4a5.205,5.205,0,0,0,5.2,5.2H9.4a5.205,5.205,0,0,0,5.2-5.2V6.6A5.206,5.206,0,0,0,9.4,1.4H6.6A5.206,5.206,0,0,0,1.4,6.6Zm3.1,4.6a.5.5,0,0,1-.5-.5v-.661a.5.5,0,0,1,.5-.5H8.072a.5.5,0,0,1,.5.5V10.7a.5.5,0,0,1-.5.5Zm0-2.769a.5.5,0,0,1-.5-.5V7.268a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5V7.93a.5.5,0,0,1-.5.5Zm0-2.769a.5.5,0,0,1-.5-.5V4.5A.5.5,0,0,1,4.5,4h7a.5.5,0,0,1,.5.5v.661a.5.5,0,0,1-.5.5Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/finance-manager.svg
// module id = eHBn
// module chunks = 115